import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const watchlistImporterSelectors = importerSelectors(
  'watchlist.importer',
);

export default watchlistImporterSelectors;
